import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { CTAButton } from 'components/atoms/Button/Button';
import LoaderSpinner from 'components/atoms/Loader/LoaderSpinner';
import { useGetEnabledNewsQuery } from 'app/api/gatewayApiSlice';
import MetaDecorator from 'components/layout/MetaDecorator';
import { NewsHero } from './hero/newsHero';
import { NewsList } from './list/newsList';

export function News() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [allItems, setAllItems] = useState([]);

  const {
    data, isLoading, isFetching, error, refetch,
  } = useGetEnabledNewsQuery({
    page,
    pageSize: 4,
  });

  const items = allItems;
  const totalCount = data?.totalCount ?? 0;
  const hasMore = items.length < totalCount;

  useEffect(() => {
    if (!data?.result) return;

    setAllItems((prev) => {
      const map = new Map();

      [...prev, ...data.result].forEach((item) => {
        map.set(item.id, item);
      });

      return Array.from(map.values());
    });
  }, [data]);

  const handleLoadMore = () => {
    if (!isFetching && hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  const handleReadMore = (aliasPath) => {
    navigate(`/news/${aliasPath}`);
  };

  const handleLoadAgain = () => {
    refetch();
  };

  if (isLoading) return <LoaderSpinner />;

  return (
    <div className='newsScreenContainer'>
      <MetaDecorator
        domain={process.env.REACT_APP_PUBLIC_URL}
        title='News'
        description='Stay up to date with the latest news, updates, and announcements from Roland Cloud.'
        link='news'
      />
      <NewsHero />
      {error ? (
        <div className='news-error'>
          <p className='proxima-nova-bold'>We couldn’t load the latest news.</p>
          <CTAButton
            ctaText={isFetching ? 'Loading...' : 'Try again'}
            onClick={handleLoadAgain}
            showIcon={false}
            className='loadNewsBtn'
          />
        </div>
      ) : (
        <>
          <NewsList items={items} handleReadMore={handleReadMore} />
          {hasMore && (
            <div className='load-more-container'>
              <CTAButton
                ctaText={isFetching ? 'Loading...' : 'Load More'}
                onClick={handleLoadMore}
                showIcon={false}
                className='loadNewsBtn'
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}
